import { ArrowUp } from "lucide-react";
import { useEffect, useState } from "react";

export const ScrollTop = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 1.2);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      type="button"
      className={`lp-totop${show ? " is-on" : ""}`}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Remonter en haut de la page"
      tabIndex={show ? 0 : -1}
      data-testid="scroll-top-btn"
    >
      <ArrowUp size={18} strokeWidth={2.4} />
    </button>
  );
};
